import { ReactElement, ReactNode } from "react";

export const NOOP = (): void => {};

/*
 * Prepares a story for rendering in Storybook.
 * It wraps the story component and adds documentation parameters.
 * This is useful for ensuring that the story can be rendered and documented correctly.
 * Importantly, it preserves the original source code of the story for documentation purposes
 * which appears under code section of each story.
 *
 * @param Story - The story component to prepare.
 * @returns An object containing the render function and documentation parameters.
 */
export const prepareStory = (
  Story: (props: any, context?: any) => ReactElement | ReactNode
): { [key: string]: any } => {
  const res = {
    render: Story,
    parameters: {
      docs: {
        source: {
          // @ts-ignore
          originalSource: Story.__RAW__,
          type: "code",
        },
      },
    },
    args: (Story as any)?.args,
  };
  // @ts-ignore
  res.__RAW__ = Story.__RAW__;
  return res;
};
